import qukan from './Qukan';
import perm from './Perm';
import quxs from './Quxs';
import audit from './Audit';

export default {
    qukan,
    perm,
    quxs,
    audit
};
